import * as yup from 'yup';
import { useFormik } from 'formik';
import { defaultValue } from '@entities/card-schema/model';
import { nonNegativeNumberField, optionalDescriptionField, requiredTextField, } from './yup-helpers';
const mergeWithDefaults = (current) => {
    if (!current) {
        return { ...defaultValue };
    }
    return { ...defaultValue, ...current };
};
export const form = (props) => {
    const validationSchema = yup.object().shape({
        schemaCode: requiredTextField().nullable(),
        schemaName: requiredTextField().nullable(),
        description: optionalDescriptionField(),
        bin: requiredTextField().nullable(),
        cardRangeStart: requiredTextField().nullable(),
        cardRangeEnd: requiredTextField().nullable(),
        cardLength: nonNegativeNumberField(),
        cardNetworkCode: requiredTextField().nullable(),
        issuerId: requiredTextField().nullable(),
        isActive: yup.boolean().nullable(),
    });
    const formik = useFormik({
        initialValues: mergeWithDefaults(props.current),
        enableReinitialize: true,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit(data) {
            if (props.current?.id) {
                props.updateEntity({
                    ...props.current,
                    ...data,
                });
            }
            else {
                props.createEntity({
                    ...data,
                });
            }
        },
    });
    return formik;
};
